import React from 'react';
import { useHistory } from 'react-router-dom';
import { SessionState } from '../../../reducers/auth/session';
import { Grid, Paper, Typography, Button } from '@mui/material';
import { AppState } from '../../../reducers/index';
import { connect } from 'react-redux';
//import { ConfigState } from '../../../reducers/config';
//import { fetchConfig } from '../../../actions/config';
//import { ThumbUp } from '@mui/icons-material';
import littleIS from '../../images/littleIS.png'
//import InfoCard from '../../Utils/InfoCard';
import { useTranslation } from 'react-i18next';
import { PERSON } from '../../../models/User';
import { roleToURLPrefix } from '../../../App';


interface Props {
  session: SessionState
  //config: ConfigState;
}

//const AdminDashboard: React.FC<Props> = ({ session, config }) => {
const AdminDashboard: React.FC<Props> = ({ session }) => {
  const history = useHistory();
  const { t } = useTranslation('dashboard')
  
  /*
  useEffect(() => {
      dispatch(fetchConfig);
    }, [dispatch]);
  */
  var tasks: any[] = []

  //  const endOfClasses = moment(config.config?.lastClassDate);
  if (session.shouldUpdatePassword) tasks.push(
    <Task key="updatePass">
      Tenés una contraseña automática, por favor cambiala a una personal en
      <Button size="small" onClick={() => history.push(`/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/profile`)}
      >Mi Perfil</Button>.
    </Task>
  )

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper>
            <Typography variant="body1">
              {t('welcome')}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

/*
        
        <Grid item xs={12}>
          <Typography variant="h6">
            Tareas pendientes
          </Typography>
        </Grid>
        {tasks.length ? tasks : <Grid item xs={12}>
          <Typography variant="body1">
            No tenés tareas pendientes
            &nbsp;&nbsp;<ThumbUp />
          </Typography>
        </Grid>}

        <Grid item xs={12}>
          <Typography variant="h6">
            Recordatorios
          </Typography>
        </Grid>
        <InfoCard>Dato InfoCard.</InfoCard>
*/


type TaskProps = {
  children?: React.ReactNode
};

const Task: React.FC<TaskProps> = ({ children }) => {
  return <Grid item xs={4}>
    <Paper>
      <Typography variant="body1">
        <img alt="task" src={littleIS} />&nbsp;&nbsp;
        {children}
      </Typography>
    </Paper>
  </Grid>
}

const mapStateToProps = (state: AppState) => ({
  session: state.session,
  notificationList: state.notificationList
  //,config: state.config
})

export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(AdminDashboard);
